import { PageFade } from "@/components/site/motion";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function Contact() {
  useDocumentTitle("Contact — JARE");
  return <PageFade />;
}
